module.exports = __webpack_public_path__ + "static/media/B&TScreenshot8.31b45034.png";